module.exports = __webpack_public_path__ + "img/rrt_example_result.ecac8705.png";